<template>
  <f7-page class="page-bot-config">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>Cấu hình Bot</f7-nav-title>
    </f7-navbar>
    <template v-if="user_info.server_region === 'hanoi'">
      <f7-block-title>THỜI GIAN NHẬN TIN</f7-block-title>
      <f7-list inset inline-labels>
        <li>
          <div class="item-content item-input item-input-with-value">
            <div class="item-inner">
              <div class="item-title item-label">Miền Bắc</div>
              <div class="item-input-wrap">
                <input type="text" class="input-with-value" :value="form_config.mb_bot_region_switch_at" id="mb-auto-picker" readonly>
              </div>
            </div>
          </div>
        </li>
      </f7-list>
      <f7-list inset inline-labels>
        <f7-list-item title="Nhận diện tin nhắn thường">
          <f7-icon slot="media" ios="f7:cube" color="crimson"></f7-icon>
          <f7-toggle slot="after" :checked="!!user_info.user_configs.warning_human_chat" @toggle:change="toggleWarningHumanChat"></f7-toggle>
        </f7-list-item>
        <f7-list-item title="Cho hủy tin">
          <f7-icon slot="media" ios="f7:cube" color="crimson"></f7-icon>
          <f7-toggle slot="after" :checked="form_config.allow_deny_message === 1" @toggle:change="toggleDeny"></f7-toggle>
        </f7-list-item>
        <f7-list-item title="Tự động gửi báo cáo">
          <f7-icon slot="media" ios="f7:cube" color="crimson"></f7-icon>
          <f7-toggle slot="after" :checked="form_config.allow_bot_auto_send_summary_report === 1" @toggle:change="toggleBotReport"></f7-toggle>
        </f7-list-item>
        <f7-list-input
          v-if="form_config.allow_deny_message"
          type="select"
          label="Thời gian cho phép"
          placeholder="- Chọn -"
          :value="form_config.allow_deny_within_minutes"
          @input="form_config.allow_deny_within_minutes = $event.target.value"
        >
          <f7-icon ios="f7:clock" slot="media"></f7-icon>
          <option value="1">1 phút</option>
          <option value="2">2 phút</option>
          <option value="3">3 phút</option>
          <option value="4">4 phút</option>
          <option value="5">5 phút</option>
          <option value="6">6 phút</option>
          <option value="7">7 phút</option>
          <option value="8">8 phút</option>
          <option value="9">9 phút</option>
          <option value="10">10 phút</option>
        </f7-list-input>
      </f7-list>
      <f7-block inset class="mb-0">
        <f7-segmented strong class="mb-1">
          <f7-button small :active="weekday_tab_active === 'monday'" @click.prevent="weekday_tab_active = 'monday'">
            T2
          </f7-button>
          <f7-button small :active="weekday_tab_active === 'tuesday'" @click.prevent="weekday_tab_active = 'tuesday'">
            T3
          </f7-button>
          <f7-button small :active="weekday_tab_active === 'wednesday'" @click.prevent="weekday_tab_active = 'wednesday'">
            T4
          </f7-button>
          <f7-button small :active="weekday_tab_active === 'thursday'" @click.prevent="weekday_tab_active = 'thursday'">
            T5
          </f7-button>
          <f7-button small :active="weekday_tab_active === 'friday'" @click.prevent="weekday_tab_active = 'friday'">
            T6
          </f7-button>
          <f7-button small :active="weekday_tab_active === 'saturday'" @click.prevent="weekday_tab_active = 'saturday'">
            T7
          </f7-button>
          <f7-button small :active="weekday_tab_active === 'sunday'" @click.prevent="weekday_tab_active = 'sunday'">
            CN
          </f7-button>
        </f7-segmented>
      </f7-block>
      <template v-if="region_tab_active === 'MB' && weekday_tab_active === 'monday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mb-monday-mb"
                       :value="form_config.mb.monday.mb.end_at"
                       @click.prevent="openPicker('mb', 'monday', 'mb')">
                <f7-button fill :color="form_config['mb']['monday']['mb'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mb', 'monday', 'mb')">
                  <span v-if="form_config['mb']['monday']['mb'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MB' && weekday_tab_active === 'tuesday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mb-tuesday-mb"
                       :value="form_config.mb.tuesday.mb.end_at"
                       @click.prevent="openPicker('mb', 'tuesday', 'mb')">
                <f7-button fill :color="form_config['mb']['tuesday']['mb'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mb', 'tuesday', 'mb')">
                  <span v-if="form_config['mb']['tuesday']['mb'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MB' && weekday_tab_active === 'wednesday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mb-wednesday-mb"
                       :value="form_config.mb.wednesday.mb.end_at"
                       @click.prevent="openPicker('mb', 'wednesday', 'mb')">
                <f7-button fill :color="form_config['mb']['wednesday']['mb'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mb', 'wednesday', 'mb')">
                  <span v-if="form_config['mb']['wednesday']['mb'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MB' && weekday_tab_active === 'thursday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mb-thursday-mb"
                       :value="form_config.mb.thursday.mb.end_at"
                       @click.prevent="openPicker('mb', 'thursday', 'mb')">
                <f7-button fill :color="form_config['mb']['thursday']['mb'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mb', 'thursday', 'mb')">
                  <span v-if="form_config['mb']['thursday']['mb'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MB' && weekday_tab_active === 'friday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mb-friday-mb"
                       :value="form_config.mb.friday.mb.end_at"
                       @click.prevent="openPicker('mb', 'friday', 'mb')">
                <f7-button fill :color="form_config['mb']['friday']['mb'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mb', 'friday', 'mb')">
                  <span v-if="form_config['mb']['friday']['mb'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MB' && weekday_tab_active === 'saturday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mb-saturday-mb"
                       :value="form_config.mb.saturday.mb.end_at"
                       @click.prevent="openPicker('mb', 'saturday', 'mb')">
                <f7-button fill :color="form_config['mb']['saturday']['mb'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mb', 'saturday', 'mb')">
                  <span v-if="form_config['mb']['saturday']['mb'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MB' && weekday_tab_active === 'sunday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mb-sunday-mb"
                       :value="form_config.mb.sunday.mb.end_at"
                       @click.prevent="openPicker('mb', 'sunday', 'mb')">
                <f7-button fill :color="form_config['mb']['sunday']['mb'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mb', 'sunday', 'mb')">
                  <span v-if="form_config['mb']['sunday']['mb'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
    </template>
    <template v-else>
      <f7-block-title>THỜI GIAN CHUYỂN VÙNG</f7-block-title>
      <f7-list inset inline-labels>
        <li>
          <div class="item-content item-input item-input-with-value">
            <div class="item-inner">
              <div class="item-title item-label">Miền Nam</div>
              <div class="item-input-wrap">
                <input type="text" class="input-with-value" :value="form_config.mn_bot_region_switch_at" id="mn-auto-picker" readonly>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content item-input item-input-with-value">
            <div class="item-inner">
              <div class="item-title item-label">Miền Trung</div>
              <div class="item-input-wrap">
                <input type="text" class="input-with-value" :value="form_config.mt_bot_region_switch_at" id="mt-auto-picker" readonly>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content item-input item-input-with-value">
            <div class="item-inner">
              <div class="item-title item-label">Miền Bắc</div>
              <div class="item-input-wrap">
                <input type="text" class="input-with-value" :value="form_config.mb_bot_region_switch_at" id="mb-auto-picker" readonly>
              </div>
            </div>
          </div>
        </li>
      </f7-list>
      <f7-list inset inline-labels>
        <f7-list-item title="Nhận diện tin nhắn thường">
          <f7-icon slot="media" ios="f7:cube" color="crimson"></f7-icon>
          <f7-toggle slot="after" :checked="!!user_info.user_configs.warning_human_chat" @toggle:change="toggleWarningHumanChat"></f7-toggle>
        </f7-list-item>
        <f7-list-item title="Cho hủy tin">
          <f7-icon slot="media" ios="f7:cube" color="crimson"></f7-icon>
          <f7-toggle slot="after" :checked="form_config.allow_deny_message === 1" @toggle:change="toggleDeny"></f7-toggle>
        </f7-list-item>
        <f7-list-item title="Tự động gửi báo cáo">
          <f7-icon slot="media" ios="f7:cube" color="crimson"></f7-icon>
          <f7-toggle slot="after" :checked="form_config.allow_bot_auto_send_summary_report === 1" @toggle:change="toggleBotReport"></f7-toggle>
        </f7-list-item>
        <f7-list-input
          v-if="form_config.allow_deny_message"
          type="select"
          label="Thời gian cho phép"
          placeholder="- Chọn -"
          :value="form_config.allow_deny_within_minutes"
          @input="form_config.allow_deny_within_minutes = $event.target.value"
        >
          <f7-icon ios="f7:clock" slot="media"></f7-icon>
          <option value="1">1 phút</option>
          <option value="2">2 phút</option>
          <option value="3">3 phút</option>
          <option value="4">4 phút</option>
          <option value="5">5 phút</option>
          <option value="6">6 phút</option>
          <option value="7">7 phút</option>
          <option value="8">8 phút</option>
          <option value="9">9 phút</option>
          <option value="10">10 phút</option>
        </f7-list-input>
      </f7-list>
      <f7-block inset class="mb-0">
        <f7-segmented strong class="mb-1">
          <f7-button small :active="region_tab_active === 'MN'" @click.prevent="region_tab_active = 'MN'">
            MN
          </f7-button>
          <f7-button small :active="region_tab_active === 'MT'" @click.prevent="region_tab_active = 'MT'">
            MT
          </f7-button>
          <f7-button small :active="region_tab_active === 'MB'" @click.prevent="region_tab_active = 'MB'">
            MB
          </f7-button>
        </f7-segmented>
        <f7-segmented strong class="mb-1">
          <f7-button small :active="weekday_tab_active === 'monday'" @click.prevent="weekday_tab_active = 'monday'">
            T2
          </f7-button>
          <f7-button small :active="weekday_tab_active === 'tuesday'" @click.prevent="weekday_tab_active = 'tuesday'">
            T3
          </f7-button>
          <f7-button small :active="weekday_tab_active === 'wednesday'" @click.prevent="weekday_tab_active = 'wednesday'">
            T4
          </f7-button>
          <f7-button small :active="weekday_tab_active === 'thursday'" @click.prevent="weekday_tab_active = 'thursday'">
            T5
          </f7-button>
          <f7-button small :active="weekday_tab_active === 'friday'" @click.prevent="weekday_tab_active = 'friday'">
            T6
          </f7-button>
          <f7-button small :active="weekday_tab_active === 'saturday'" @click.prevent="weekday_tab_active = 'saturday'">
            T7
          </f7-button>
          <f7-button small :active="weekday_tab_active === 'sunday'" @click.prevent="weekday_tab_active = 'sunday'">
            CN
          </f7-button>
        </f7-segmented>
      </f7-block>
      <template v-if="region_tab_active === 'MN' && weekday_tab_active === 'monday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">HCM</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-monday-tp"
                       :value="form_config.mn.monday.tp.end_at"
                       @click.prevent="openPicker('mn', 'monday', 'tp')">
                <f7-button fill :color="form_config['mn']['monday']['tp'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'monday', 'tp')">
                  <span v-if="form_config['mn']['monday']['tp'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Đồng Tháp</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-monday-dt"
                       :value="form_config.mn.monday.dt.end_at"
                       @click.prevent="openPicker('mn', 'monday', 'dt')">
                <f7-button fill :color="form_config['mn']['monday']['dt'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'monday', 'dt')">
                  <span v-if="form_config['mn']['monday']['dt'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
        </f7-row>
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Cà Mau</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-monday-cm"
                       :value="form_config.mn.monday.cm.end_at"
                       @click.prevent="openPicker('mn', 'monday', 'cm')">
                <f7-button fill :color="form_config['mn']['monday']['cm'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'monday', 'cm')">
                  <span v-if="form_config['mn']['monday']['cm'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MN' && weekday_tab_active === 'tuesday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Bến Tre</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-tuesday-bt"
                       :value="form_config.mn.tuesday.bt.end_at"
                       @click.prevent="openPicker('mn', 'tuesday', 'bt')">
                <f7-button fill :color="form_config['mn']['tuesday']['bt'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'tuesday', 'bt')">
                  <span v-if="form_config['mn']['tuesday']['bt'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Vũng Tàu</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-tuesday-vt"
                       :value="form_config.mn.tuesday.vt.end_at"
                       @click.prevent="openPicker('mn', 'tuesday', 'vt')">
                <f7-button fill :color="form_config['mn']['tuesday']['vt'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'tuesday', 'vt')">
                  <span v-if="form_config['mn']['tuesday']['vt'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
        </f7-row>
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Bạc Liêu</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-tuesday-bli"
                       :value="form_config.mn.tuesday.bli.end_at"
                       @click.prevent="openPicker('mn', 'tuesday', 'bli')">
                <f7-button fill :color="form_config['mn']['tuesday']['bli'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'tuesday', 'bli')">
                  <span v-if="form_config['mn']['tuesday']['bli'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MN' && weekday_tab_active === 'wednesday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Đồng Nai</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-wednesday-dn"
                       :value="form_config.mn.wednesday.dn.end_at"
                       @click.prevent="openPicker('mn', 'wednesday', 'dn')">
                <f7-button fill :color="form_config['mn']['wednesday']['dn'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'wednesday', 'dn')">
                  <span v-if="form_config['mn']['wednesday']['dn'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Cần Thơ</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-wednesday-ct"
                       :value="form_config.mn.wednesday.ct.end_at"
                       @click.prevent="openPicker('mn', 'wednesday', 'ct')">
                <f7-button fill :color="form_config['mn']['wednesday']['ct'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'wednesday', 'ct')">
                  <span v-if="form_config['mn']['wednesday']['ct'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
        </f7-row>
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Sóc Trăng</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-wednesday-st"
                       :value="form_config.mn.wednesday.st.end_at"
                       @click.prevent="openPicker('mn', 'wednesday', 'st')">
                <f7-button fill :color="form_config['mn']['wednesday']['st'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'wednesday', 'st')">
                  <span v-if="form_config['mn']['wednesday']['st'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MN' && weekday_tab_active === 'thursday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Tây Ninh</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-thursday-tn"
                       :value="form_config.mn.thursday.tn.end_at"
                       @click.prevent="openPicker('mn', 'thursday', 'tn')">
                <f7-button fill :color="form_config['mn']['thursday']['tn'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'thursday', 'tn')">
                  <span v-if="form_config['mn']['thursday']['tn'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">An Giang</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-thursday-ag"
                       :value="form_config.mn.thursday.ag.end_at"
                       @click.prevent="openPicker('mn', 'thursday', 'ag')">
                <f7-button fill :color="form_config['mn']['thursday']['ag'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'thursday', 'ag')">
                  <span v-if="form_config['mn']['thursday']['ag'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
        </f7-row>
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Bình Thuận</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-thursday-bth"
                       :value="form_config.mn.thursday.bth.end_at"
                       @click.prevent="openPicker('mn', 'thursday', 'bth')">
                <f7-button fill :color="form_config['mn']['thursday']['bth'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'thursday', 'bth')">
                  <span v-if="form_config['mn']['thursday']['bth'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MN' && weekday_tab_active === 'friday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Vĩnh Long</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-friday-vl"
                       :value="form_config.mn.friday.vl.end_at"
                       @click.prevent="openPicker('mn', 'friday', 'vl')">
                <f7-button fill :color="form_config['mn']['friday']['vl'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'friday', 'vl')">
                  <span v-if="form_config['mn']['friday']['vl'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Bình Dương</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-friday-bd"
                       :value="form_config.mn.friday.bd.end_at"
                       @click.prevent="openPicker('mn', 'friday', 'bd')">
                <f7-button fill :color="form_config['mn']['friday']['bd'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'friday', 'bd')">
                  <span v-if="form_config['mn']['friday']['bd'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
        </f7-row>
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Trà Vinh</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-friday-tv"
                       :value="form_config.mn.friday.tv.end_at"
                       @click.prevent="openPicker('mn', 'friday', 'tv')">
                <f7-button fill :color="form_config['mn']['friday']['tv'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'friday', 'tv')">
                  <span v-if="form_config['mn']['friday']['tv'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MN' && weekday_tab_active === 'saturday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">HCM</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-saturday-tp"
                       :value="form_config.mn.saturday.tp.end_at"
                       @click.prevent="openPicker('mn', 'saturday', 'tp')">
                <f7-button fill :color="form_config['mn']['saturday']['tp'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'saturday', 'tp')">
                  <span v-if="form_config['mn']['saturday']['tp'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Long An</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-saturday-la"
                       :value="form_config.mn.saturday.la.end_at"
                       @click.prevent="openPicker('mn', 'saturday', 'la')">
                <f7-button fill :color="form_config['mn']['saturday']['la'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'saturday', 'la')">
                  <span v-if="form_config['mn']['saturday']['la'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
        </f7-row>
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Bình Phước</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-saturday-bp"
                       :value="form_config.mn.saturday.bp.end_at"
                       @click.prevent="openPicker('mn', 'saturday', 'bp')">
                <f7-button fill :color="form_config['mn']['saturday']['bp'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'saturday', 'bp')">
                  <span v-if="form_config['mn']['saturday']['bp'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Hậu Giang</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-saturday-hg"
                       :value="form_config.mn.saturday.hg.end_at"
                       @click.prevent="openPicker('mn', 'saturday', 'hg')">
                <f7-button fill :color="form_config['mn']['saturday']['hg'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'saturday', 'hg')">
                  <span v-if="form_config['mn']['saturday']['hg'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MN' && weekday_tab_active === 'sunday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Tiền Giang</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-sunday-tg"
                       :value="form_config.mn.sunday.tg.end_at"
                       @click.prevent="openPicker('mn', 'sunday', 'tg')">
                <f7-button fill :color="form_config['mn']['sunday']['tg'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'sunday', 'tg')">
                  <span v-if="form_config['mn']['sunday']['tg'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Kiên Giang</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-sunday-kg"
                       :value="form_config.mn.sunday.kg.end_at"
                       @click.prevent="openPicker('mn', 'sunday', 'kg')">
                <f7-button fill :color="form_config['mn']['sunday']['kg'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'sunday', 'kg')">
                  <span v-if="form_config['mn']['sunday']['kg'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
        </f7-row>
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Đà Lạt</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mn-sunday-dl"
                       :value="form_config.mn.sunday.dl.end_at"
                       @click.prevent="openPicker('mn', 'sunday', 'dl')">
                <f7-button fill :color="form_config['mn']['sunday']['dl'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mn', 'sunday', 'dl')">
                  <span v-if="form_config['mn']['sunday']['dl'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MT' && weekday_tab_active === 'monday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Phú Yên</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mt-monday-py"
                       :value="form_config.mt.monday.py.end_at"
                       @click.prevent="openPicker('mt', 'monday', 'py')">
                <f7-button fill :color="form_config['mt']['monday']['py'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mt', 'monday', 'py')">
                  <span v-if="form_config['mt']['monday']['py'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Thừa T.Huế</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mt-monday-th"
                       :value="form_config.mt.monday.th.end_at"
                       @click.prevent="openPicker('mt', 'monday', 'th')">
                <f7-button fill :color="form_config['mt']['monday']['th'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mt', 'monday', 'th')">
                  <span v-if="form_config['mt']['monday']['th'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MT' && weekday_tab_active === 'tuesday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Đắk Lắk</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mt-tuesday-dl"
                       :value="form_config.mt.tuesday.dl.end_at"
                       @click.prevent="openPicker('mt', 'tuesday', 'dl')">
                <f7-button fill :color="form_config['mt']['tuesday']['dl'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mt', 'tuesday', 'dl')">
                  <span v-if="form_config['mt']['tuesday']['dl'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Quảng Nam</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mt-tuesday-qn"
                       :value="form_config.mt.tuesday.qn.end_at"
                       @click.prevent="openPicker('mt', 'tuesday', 'qn')">
                <f7-button fill :color="form_config['mt']['tuesday']['qn'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mt', 'tuesday', 'qn')">
                  <span v-if="form_config['mt']['tuesday']['qn'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MT' && weekday_tab_active === 'wednesday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Đà Nẵng</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mt-wednesday-dn"
                       :value="form_config.mt.wednesday.dn.end_at"
                       @click.prevent="openPicker('mt', 'wednesday', 'dn')">
                <f7-button fill :color="form_config['mt']['wednesday']['dn'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mt', 'wednesday', 'dn')">
                  <span v-if="form_config['mt']['wednesday']['dn'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Khánh Hòa</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mt-wednesday-kh"
                       :value="form_config.mt.wednesday.kh.end_at"
                       @click.prevent="openPicker('mt', 'wednesday', 'kh')">
                <f7-button fill :color="form_config['mt']['wednesday']['kh'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mt', 'wednesday', 'kh')">
                  <span v-if="form_config['mt']['wednesday']['kh'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MT' && weekday_tab_active === 'thursday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Bình Định</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mt-thursday-bd"
                       :value="form_config.mt.thursday.bd.end_at"
                       @click.prevent="openPicker('mt', 'thursday', 'bd')">
                <f7-button fill :color="form_config['mt']['thursday']['bd'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mt', 'thursday', 'bd')">
                  <span v-if="form_config['mt']['thursday']['bd'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Quảng Trị</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mt-thursday-qt"
                       :value="form_config.mt.thursday.qt.end_at"
                       @click.prevent="openPicker('mt', 'thursday', 'qt')">
                <f7-button fill :color="form_config['mt']['thursday']['qt'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mt', 'thursday', 'qt')">
                  <span v-if="form_config['mt']['thursday']['qt'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
        </f7-row>
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Quảng Bình</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mt-thursday-qb"
                       :value="form_config.mt.thursday.qb.end_at"
                       @click.prevent="openPicker('mt', 'thursday', 'qb')">
                <f7-button fill :color="form_config['mt']['thursday']['qb'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mt', 'thursday', 'qb')">
                  <span v-if="form_config['mt']['thursday']['qb'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MT' && weekday_tab_active === 'friday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Gia Lai</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mt-friday-gl"
                       :value="form_config.mt.friday.gl.end_at"
                       @click.prevent="openPicker('mt', 'friday', 'gl')">
                <f7-button fill :color="form_config['mt']['friday']['gl'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mt', 'friday', 'gl')">
                  <span v-if="form_config['mt']['friday']['gl'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Ninh Thuận</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mt-friday-nt"
                       :value="form_config.mt.friday.nt.end_at"
                       @click.prevent="openPicker('mt', 'friday', 'nt')">
                <f7-button fill :color="form_config['mt']['friday']['nt'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mt', 'friday', 'nt')">
                  <span v-if="form_config['mt']['friday']['nt'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MT' && weekday_tab_active === 'saturday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Đà Nẵng</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mt-saturday-dn"
                       :value="form_config.mt.saturday.dn.end_at"
                       @click.prevent="openPicker('mt', 'saturday', 'dn')">
                <f7-button fill :color="form_config['mt']['saturday']['dn'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mt', 'saturday', 'dn')">
                  <span v-if="form_config['mt']['saturday']['dn'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Quảng Ngãi</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mt-saturday-qn"
                       :value="form_config.mt.saturday.qn.end_at"
                       @click.prevent="openPicker('mt', 'saturday', 'qn')">
                <f7-button fill :color="form_config['mt']['saturday']['qn'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mt', 'saturday', 'qn')">
                  <span v-if="form_config['mt']['saturday']['qn'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
        </f7-row>
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Đắk Nông</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mt-saturday-dno"
                       :value="form_config.mt.saturday.dno.end_at"
                       @click.prevent="openPicker('mt', 'saturday', 'dno')">
                <f7-button fill :color="form_config['mt']['saturday']['dno'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mt', 'saturday', 'dno')">
                  <span v-if="form_config['mt']['saturday']['dno'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MT' && weekday_tab_active === 'sunday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Kon Tum</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mt-sunday-kt"
                       :value="form_config.mt.sunday.kt.end_at"
                       @click.prevent="openPicker('mt', 'sunday', 'kt')">
                <f7-button fill :color="form_config['mt']['sunday']['kt'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mt', 'sunday', 'kt')">
                  <span v-if="form_config['mt']['sunday']['kt'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Khánh Hòa</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mt-sunday-kh"
                       :value="form_config.mt.sunday.kh.end_at"
                       @click.prevent="openPicker('mt', 'sunday', 'kh')">
                <f7-button fill :color="form_config['mt']['sunday']['kh'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mt', 'sunday', 'kh')">
                  <span v-if="form_config['mt']['sunday']['kh'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
        </f7-row>
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5 class="mb-1">Thừa T.Huế</h5>
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mt-sunday-th"
                       :value="form_config.mt.sunday.th.end_at"
                       @click.prevent="openPicker('mt', 'sunday', 'th')">
                <f7-button fill :color="form_config['mt']['sunday']['th'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mt', 'sunday', 'th')">
                  <span v-if="form_config['mt']['sunday']['th'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MB' && weekday_tab_active === 'monday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mb-monday-mb"
                       :value="form_config.mb.monday.mb.end_at"
                       @click.prevent="openPicker('mb', 'monday', 'mb')">
                <f7-button fill :color="form_config['mb']['monday']['mb'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mb', 'monday', 'mb')">
                  <span v-if="form_config['mb']['monday']['mb'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MB' && weekday_tab_active === 'tuesday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mb-tuesday-mb"
                       :value="form_config.mb.tuesday.mb.end_at"
                       @click.prevent="openPicker('mb', 'tuesday', 'mb')">
                <f7-button fill :color="form_config['mb']['tuesday']['mb'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mb', 'tuesday', 'mb')">
                  <span v-if="form_config['mb']['tuesday']['mb'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MB' && weekday_tab_active === 'wednesday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mb-wednesday-mb"
                       :value="form_config.mb.wednesday.mb.end_at"
                       @click.prevent="openPicker('mb', 'wednesday', 'mb')">
                <f7-button fill :color="form_config['mb']['wednesday']['mb'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mb', 'wednesday', 'mb')">
                  <span v-if="form_config['mb']['wednesday']['mb'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MB' && weekday_tab_active === 'thursday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mb-thursday-mb"
                       :value="form_config.mb.thursday.mb.end_at"
                       @click.prevent="openPicker('mb', 'thursday', 'mb')">
                <f7-button fill :color="form_config['mb']['thursday']['mb'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mb', 'thursday', 'mb')">
                  <span v-if="form_config['mb']['thursday']['mb'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MB' && weekday_tab_active === 'friday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mb-friday-mb"
                       :value="form_config.mb.friday.mb.end_at"
                       @click.prevent="openPicker('mb', 'friday', 'mb')">
                <f7-button fill :color="form_config['mb']['friday']['mb'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mb', 'friday', 'mb')">
                  <span v-if="form_config['mb']['friday']['mb'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MB' && weekday_tab_active === 'saturday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mb-saturday-mb"
                       :value="form_config.mb.saturday.mb.end_at"
                       @click.prevent="openPicker('mb', 'saturday', 'mb')">
                <f7-button fill :color="form_config['mb']['saturday']['mb'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mb', 'saturday', 'mb')">
                  <span v-if="form_config['mb']['saturday']['mb'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
      <template v-else-if="region_tab_active === 'MB' && weekday_tab_active === 'sunday'">
        <f7-row class="mb-1">
          <f7-col>
            <f7-card>
              <f7-card-content class="text-align-center">
                <p class="mb-1">Giờ ngưng</p>
                <input type="text" class="input-with-value border-color-gray border-1 text-align-center mb-1"
                       id="mb-sunday-mb"
                       :value="form_config.mb.sunday.mb.end_at"
                       @click.prevent="openPicker('mb', 'sunday', 'mb')">
                <f7-button fill :color="form_config['mb']['sunday']['mb'].channel_active ? 'green' : 'orange'" @click.prevent="toggleActive('mb', 'sunday', 'mb')">
                  <span v-if="form_config['mb']['sunday']['mb'].channel_active">HOẠT ĐỘNG</span>
                  <span v-else>TẠM DỪNG</span>
                </f7-button>
              </f7-card-content>
            </f7-card>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </template>
    </template>
    <f7-block inset>
      <f7-button fill color="primary" @click.prevent="updateConfig">LƯU CẤU HÌNH</f7-button>
    </f7-block>
  </f7-page>
</template>
<style>
.card input.input-with-value.border-color-gray {
  font-size : 16px
}
</style>
<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      configs: [],
      form_config: {
        "mn_bot_region_switch_at": "12:00",
        "mt_bot_region_switch_at": "16:30",
        "mb_bot_region_switch_at": "17:30",
        "allow_deny_message": 1,
        "allow_deny_within_minutes": 5,
        "allow_bot_auto_send_summary_report": 1,
        "mn": {
          "monday": {
            "tp": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            },
            "dt": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            },
            "cm": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            }
          },
          "tuesday": {
            "bt": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            },
            "vt": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            },
            "bli": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            }
          },
          "wednesday": {
            "dn": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            },
            "ct": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            },
            "st": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            }
          },
          "thursday": {
            "tn": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            },
            "ag": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            },
            "bth": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            }
          },
          "friday": {
            "vl": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            },
            "bd": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            },
            "tv": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            }
          },
          "saturday": {
            "tp": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            },
            "la": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            },
            "bp": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            },
            "hg": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            }
          },
          "sunday": {
            "tg": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            },
            "kg": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            },
            "dl": {
              "begin_at": '00:00',
              "end_at": '16:15',
              "channel_active": 1
            }
          }
        },
        "mt": {
          "monday": {
            "th": {
              "begin_at": '00:00',
              "end_at": '17:15',
              "channel_active": 1
            },
            "py": {
              "begin_at": '00:00',
              "end_at": '17:15',
              "channel_active": 1
            }
          },
          "tuesday": {
            "dl": {
              "begin_at": '00:00',
              "end_at": '17:15',
              "channel_active": 1
            },
            "qn": {
              "begin_at": '00:00',
              "end_at": '17:15',
              "channel_active": 1
            }
          },
          "wednesday": {
            "dn": {
              "begin_at": '00:00',
              "end_at": '17:15',
              "channel_active": 1
            },
            "kh": {
              "begin_at": '00:00',
              "end_at": '17:15',
              "channel_active": 1
            }
          },
          "thursday": {
            "bd": {
              "begin_at": '00:00',
              "end_at": '17:15',
              "channel_active": 1
            },
            "qt": {
              "begin_at": '00:00',
              "end_at": '17:15',
              "channel_active": 1
            },
            "qb": {
              "begin_at": '00:00',
              "end_at": '17:15',
              "channel_active": 1
            }
          },
          "friday": {
            "gl": {
              "begin_at": '00:00',
              "end_at": '17:15',
              "channel_active": 1
            },
            "nt": {
              "begin_at": '00:00',
              "end_at": '17:15',
              "channel_active": 1
            }
          },
          "saturday": {
            "dn": {
              "begin_at": '00:00',
              "end_at": '17:15',
              "channel_active": 1
            },
            "qn": {
              "begin_at": '00:00',
              "end_at": '17:15',
              "channel_active": 1
            },
            "dno": {
              "begin_at": '00:00',
              "end_at": '17:15',
              "channel_active": 1
            }
          },
          "sunday": {
            "kt": {
              "begin_at": '00:00',
              "end_at": '17:15',
              "channel_active": 1
            },
            "kh": {
              "begin_at": '00:00',
              "end_at": '17:15',
              "channel_active": 1
            },
            "th": {
              "begin_at": '00:00',
              "end_at": '17:15',
              "channel_active": 1
            }
          }
        },
        "mb": {
          "monday": {
            "mb": {
              "begin_at": '00:00',
              "end_at": '18:15',
              "channel_active": 1
            }
          },
          "tuesday": {
            "mb": {
              "begin_at": '00:00',
              "end_at": '18:15',
              "channel_active": 1
            }
          },
          "wednesday": {
            "mb": {
              "begin_at": '00:00',
              "end_at": '18:15',
              "channel_active": 1
            }
          },
          "thursday": {
            "mb": {
              "begin_at": '00:00',
              "end_at": '18:15',
              "channel_active": 1
            }
          },
          "friday": {
            "mb": {
              "begin_at": '00:00',
              "end_at": '18:15',
              "channel_active": 1
            }
          },
          "saturday": {
            "mb": {
              "begin_at": '00:00',
              "end_at": '18:15',
              "channel_active": 1
            }
          },
          "sunday": {
            "mb": {
              "begin_at": '00:00',
              "end_at": '18:15',
              "channel_active": 1
            }
          }
        }
      },
      picker_cols: [
        {
          textAlign: 'left',
          values: ('00 01 02 03 04 05 06 07 08 09 10 11 12 13 14 15 16 17 18 19 20 21 22 23').split(' '),
        },
        {
          values: ('00 01 02 03 04 05 06 07 08 09 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56 57 58 59').split(' '),
        },
      ],
      region_tab_active: 'MN',
      weekday_tab_active: 'monday',
      mn_tab_active: 'monday',
      mt_tab_active: 'monday',
      mb_tab_active: 'monday',
      timePicker: null
    }
  },
  computed: {
    ...mapState(['user_info'])
  },
  methods: {
    getBotConfig() {
      let self = this;

      self.$f7.dialog.preloader();

      self.$store.dispatch('getBotConfig', { room_id: self.chatRoomId }).then((res) => {
        self.configs = res;

        let mn_monday_tp = self._.find(self.configs, { region: 'mn', english_week_day: 'monday', channel: 'tp' });
        let mn_monday_dt = self._.find(self.configs, { region: 'mn', english_week_day: 'monday', channel: 'dt' });
        let mn_monday_cm = self._.find(self.configs, { region: 'mn', english_week_day: 'monday', channel: 'cm' });

        let mn_tuesday_bt = self._.find(self.configs, { region: 'mn', english_week_day: 'tuesday', channel: 'bt' });
        let mn_tuesday_vt = self._.find(self.configs, { region: 'mn', english_week_day: 'tuesday', channel: 'vt' });
        let mn_tuesday_bli = self._.find(self.configs, { region: 'mn', english_week_day: 'tuesday', channel: 'bli' });
        if (self._.isEmpty(mn_tuesday_bli)) {
          mn_tuesday_bli = self._.find(self.configs, { region: 'mn', english_week_day: 'tuesday', channel: 'bl' });
        }

        let mn_wednesday_dn = self._.find(self.configs, { region: 'mn', english_week_day: 'wednesday', channel: 'dn' });
        let mn_wednesday_ct = self._.find(self.configs, { region: 'mn', english_week_day: 'wednesday', channel: 'ct' });
        let mn_wednesday_st = self._.find(self.configs, { region: 'mn', english_week_day: 'wednesday', channel: 'st' });

        let mn_thursday_tn = self._.find(self.configs, { region: 'mn', english_week_day: 'thursday', channel: 'tn' });
        let mn_thursday_ag = self._.find(self.configs, { region: 'mn', english_week_day: 'thursday', channel: 'ag' });
        let mn_thursday_bth = self._.find(self.configs, { region: 'mn', english_week_day: 'thursday', channel: 'bth' });
        if (self._.isEmpty(mn_thursday_bth)) {
          mn_thursday_bth = self._.find(self.configs, { region: 'mn', english_week_day: 'thursday', channel: 'bt' });
        }

        self.form_config = {
          "mn_bot_region_switch_at": self.user_info.user_configs.mn_bot_region_switch_at,
          "mt_bot_region_switch_at": self.user_info.user_configs.mt_bot_region_switch_at,
          "mb_bot_region_switch_at": self.user_info.user_configs.mb_bot_region_switch_at,
          "allow_deny_message": self.user_info.user_configs.allow_deny_message,
          "allow_deny_within_minutes": self.user_info.user_configs.allow_deny_within_minutes,
          "allow_bot_auto_send_summary_report": self.user_info.user_configs.allow_bot_auto_send_summary_report,
          "mn": {
            "monday": {
              "tp": {
                "begin_at": '00:00',
                "end_at": mn_monday_tp.end_at,
                "channel_active": mn_monday_tp.channel_active
              },
              "dt": {
                "begin_at": '00:00',
                "end_at": mn_monday_dt.end_at,
                "channel_active": mn_monday_dt.channel_active
              },
              "cm": {
                "begin_at": '00:00',
                "end_at": mn_monday_cm.end_at,
                "channel_active": mn_monday_cm.channel_active
              }
            },
            "tuesday": {
              "bt": {
                "begin_at": '00:00',
                "end_at": mn_tuesday_bt.end_at,
                "channel_active": mn_tuesday_bt.channel_active
              },
              "vt": {
                "begin_at": '00:00',
                "end_at": mn_tuesday_vt.end_at,
                "channel_active": mn_tuesday_vt.channel_active
              },
              "bli": {
                "begin_at": '00:00',
                "end_at": mn_tuesday_bli.end_at,
                "channel_active": mn_tuesday_bli.channel_active
              }
            },
            "wednesday": {
              "dn": {
                "begin_at": '00:00',
                "end_at": mn_wednesday_dn.end_at,
                "channel_active": mn_wednesday_dn.channel_active
              },
              "ct": {
                "begin_at": '00:00',
                "end_at": mn_wednesday_ct.end_at,
                "channel_active": mn_wednesday_ct.channel_active
              },
              "st": {
                "begin_at": '00:00',
                "end_at": mn_wednesday_st.end_at,
                "channel_active": mn_wednesday_st.channel_active
              }
            },
            "thursday": {
              "tn": {
                "begin_at": '00:00',
                "end_at": mn_thursday_tn.end_at,
                "channel_active": mn_thursday_tn.channel_active
              },
              "ag": {
                "begin_at": '00:00',
                "end_at": mn_thursday_ag.end_at,
                "channel_active": mn_thursday_ag.channel_active
              },
              "bth": {
                "begin_at": '00:00',
                "end_at": mn_thursday_bth.end_at,
                "channel_active": mn_thursday_bth.channel_active
              }
            },
            "friday": {
              "vl": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'friday',
                  channel: 'vl'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'friday',
                  channel: 'vl'
                })).channel_active
              },
              "bd": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'friday',
                  channel: 'bd'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'friday',
                  channel: 'bd'
                })).channel_active
              },
              "tv": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'friday',
                  channel: 'tv'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'friday',
                  channel: 'tv'
                })).channel_active
              }
            },
            "saturday": {
              "tp": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'saturday',
                  channel: 'tp'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'saturday',
                  channel: 'tp'
                })).channel_active
              },
              "la": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'saturday',
                  channel: 'la'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'saturday',
                  channel: 'la'
                })).channel_active
              },
              "bp": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'saturday',
                  channel: 'bp'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'saturday',
                  channel: 'bp'
                })).channel_active
              },
              "hg": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'saturday',
                  channel: 'hg'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'saturday',
                  channel: 'hg'
                })).channel_active
              }
            },
            "sunday": {
              "tg": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'sunday',
                  channel: 'tg'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'sunday',
                  channel: 'tg'
                })).channel_active
              },
              "kg": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'sunday',
                  channel: 'kg'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'sunday',
                  channel: 'kg'
                })).channel_active
              },
              "dl": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'sunday',
                  channel: 'dl'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mn',
                  english_week_day: 'sunday',
                  channel: 'dl'
                })).channel_active
              }
            }
          },
          "mt": {
            "monday": {
              "th": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'monday',
                  channel: 'th'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'monday',
                  channel: 'th'
                })).channel_active
              },
              "py": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'monday',
                  channel: 'py'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'monday',
                  channel: 'py'
                })).channel_active
              }
            },
            "tuesday": {
              "dl": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'tuesday',
                  channel: 'dl'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'tuesday',
                  channel: 'dl'
                })).channel_active
              },
              "qn": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'tuesday',
                  channel: 'qn'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'tuesday',
                  channel: 'qn'
                })).channel_active
              }
            },
            "wednesday": {
              "dn": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'wednesday',
                  channel: 'dn'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'wednesday',
                  channel: 'dn'
                })).channel_active
              },
              "kh": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'wednesday',
                  channel: 'kh'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'wednesday',
                  channel: 'kh'
                })).channel_active
              }
            },
            "thursday": {
              "bd": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'thursday',
                  channel: 'bd'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'thursday',
                  channel: 'bd'
                })).channel_active
              },
              "qt": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'thursday',
                  channel: 'qt'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'thursday',
                  channel: 'qt'
                })).channel_active
              },
              "qb": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'thursday',
                  channel: 'qb'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'thursday',
                  channel: 'qb'
                })).channel_active
              }
            },
            "friday": {
              "gl": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'friday',
                  channel: 'gl'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'friday',
                  channel: 'gl'
                })).channel_active
              },
              "nt": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'friday',
                  channel: 'nt'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'friday',
                  channel: 'nt'
                })).channel_active
              }
            },
            "saturday": {
              "dn": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'saturday',
                  channel: 'dn'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'saturday',
                  channel: 'dn'
                })).channel_active
              },
              "qn": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'saturday',
                  channel: 'qn'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'saturday',
                  channel: 'qn'
                })).channel_active
              },
              "dno": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'saturday',
                  channel: 'dno'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'saturday',
                  channel: 'dno'
                })).channel_active
              }
            },
            "sunday": {
              "kt": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'sunday',
                  channel: 'kt'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'sunday',
                  channel: 'kt'
                })).channel_active
              },
              "kh": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'sunday',
                  channel: 'kh'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'sunday',
                  channel: 'kh'
                })).channel_active
              },
              "th": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'sunday',
                  channel: 'th'
                })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mt',
                  english_week_day: 'sunday',
                  channel: 'th'
                })).channel_active
              }
            }
          },
          "mb": {
            "monday": {
              "mb": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, { region: 'mb', english_week_day: 'monday' })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mb',
                  english_week_day: 'monday'
                })).channel_active
              }
            },
            "tuesday": {
              "mb": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, { region: 'mb', english_week_day: 'tuesday' })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mb',
                  english_week_day: 'tuesday'
                })).channel_active
              }
            },
            "wednesday": {
              "mb": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, { region: 'mb', english_week_day: 'wednesday' })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mb',
                  english_week_day: 'wednesday'
                })).channel_active
              }
            },
            "thursday": {
              "mb": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, { region: 'mb', english_week_day: 'thursday' })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mb',
                  english_week_day: 'thursday'
                })).channel_active
              }
            },
            "friday": {
              "mb": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, { region: 'mb', english_week_day: 'friday' })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mb',
                  english_week_day: 'friday'
                })).channel_active
              }
            },
            "saturday": {
              "mb": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, { region: 'mb', english_week_day: 'saturday' })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mb',
                  english_week_day: 'saturday'
                })).channel_active
              }
            },
            "sunday": {
              "mb": {
                "begin_at": '00:00',
                "end_at": (self._.find(self.configs, { region: 'mb', english_week_day: 'sunday' })).end_at,
                "channel_active": (self._.find(self.configs, {
                  region: 'mb',
                  english_week_day: 'sunday'
                })).channel_active
              }
            }
          }
        }
        self.buildPickers();

        self.$f7.dialog.close();
      }).catch((err) => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert(err, 'LỖI!');
      });
    },
    buildPickers() {
      let self = this;
      self.$f7.picker.create({
        inputEl: '#mn-auto-picker',
        rotateEffect: true,
        formatValue: function(values) {
          return values[0] + ':' + values[1];
        },
        value: [self.form_config.mn_bot_region_switch_at.split(':')[0], self.form_config.mn_bot_region_switch_at.split(':')[1]],
        cols: self.picker_cols,
        on: {
          change: function(picker, values, displayValues) {
            self.form_config.mn_bot_region_switch_at = picker.value[0] + ':' + picker.value[1];
          },
        }
      });

      self.$f7.picker.create({
        inputEl: '#mt-auto-picker',
        rotateEffect: true,
        formatValue: function(values) {
          return values[0] + ':' + values[1];
        },
        value: [self.form_config.mt_bot_region_switch_at.split(':')[0], self.form_config.mt_bot_region_switch_at.split(':')[1]],
        cols: self.picker_cols,
        on: {
          change: function(picker, values, displayValues) {
            self.form_config.mt_bot_region_switch_at = picker.value[0] + ':' + picker.value[1];
          },
        }
      });

      self.$f7.picker.create({
        inputEl: '#mb-auto-picker',
        rotateEffect: true,
        formatValue: function(values) {
          return values[0] + ':' + values[1];
        },
        value: [self.form_config.mb_bot_region_switch_at.split(':')[0], self.form_config.mb_bot_region_switch_at.split(':')[1]],
        cols: self.picker_cols,
        on: {
          change: function(picker, values, displayValues) {
            self.form_config.mb_bot_region_switch_at = picker.value[0] + ':' + picker.value[1];
          },
        }
      });
    },
    openPicker(region, weekday, channel) {
      let self = this;
      if (!_.isNull(self.timePicker)) {
        self.timePicker.destroy();
      }
      self.timePicker = self.$f7.picker.create({
        inputEl: `#${region}-${weekday}-${channel}`,
        rotateEffect: true,
        formatValue: function(values) {
          return values[0] + ':' + values[1];
        },
        value: [self.form_config[region][weekday][channel].end_at.split(':')[0], self.form_config[region][weekday][channel].end_at.split(':')[1]],
        cols: self.picker_cols,
        on: {
          change: function(picker, values, displayValues) {
            self.form_config[region][weekday][channel].end_at = picker.value[0] + ':' + picker.value[1];
          },
        }
      });
      self.timePicker.open();
    },
    toggleActive(region, weekday, channel) {
      this.form_config[region][weekday][channel].channel_active = !this.form_config[region][weekday][channel].channel_active;
    },
    toggleDeny(val){
      this.form_config.allow_deny_message = val ? 1 : 0;
    },
    toggleBotReport(val) {
      this.form_config.allow_bot_auto_send_summary_report = val ? 1 : 0;
    },
    updateConfig() {
      let self = this;
      self.$f7.dialog.preloader();

      self.user_info.user_configs.allow_deny_message = self.form_config.allow_deny_message;
      self.user_info.user_configs.allow_bot_auto_send_summary_report = self.form_config.allow_bot_auto_send_summary_report;

      self.$store.dispatch('updateBotConfig', self.form_config).then(() => {
        return self.$store.dispatch('changeMeConfig', self.user_info.user_configs);
      }).then(() => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert('Đã cập nhật', 'THÀNH CÔNG!');

        self.$store.dispatch('getMe');
      }).catch((err) => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert(err, 'LỖI!');
      });
    },
    toggleWarningHumanChat(val) {
      this.user_info.user_configs.warning_human_chat = val ? 1 : 0;
    },
    openTimePicker(region, weekday, channel) {
      self.$f7.picker.create({
        rotateEffect: true,
        openIn: 'popover',
        formatValue: function(values) {
          return values[0] + ':' + values[1];
        },
        value: [self.form_config.mn_bot_region_switch_at.split(':')[0], self.form_config.mn_bot_region_switch_at.split(':')[1]],
        cols: self.picker_cols,
        on: {
          change: function(picker, values, displayValues) {
            self.form_config.mn_bot_region_switch_at = picker.value[0] + ':' + picker.value[1];
          },
        }
      });
    }
  },
  mounted() {
    let self = this;

    if (this.user_info.server_region === 'hanoi'){
      this.region_tab_active = 'MB';
    }

    self.getBotConfig();

    this.weekday_tab_active = this.$moment().format('dddd').toLowerCase();
    this.mn_tab_active = this.$moment().format('dddd').toLowerCase();
    this.mt_tab_active = this.$moment().format('dddd').toLowerCase();
    this.mb_tab_active = this.$moment().format('dddd').toLowerCase();
  }
};
</script>
